/* ZINKE 4.7 (20.09.2026) – Farbkreise und Optionsknöpfe auf der Produktseite.
   Antippen setzt das (unsichtbare) Auswahlfeld und löst den normalen
   Variantenwechsel aus assets/zinke.js aus (Bild, Preis, Verfügbarkeit). */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-z-wert]');
    if (!b) return;
    var root = b.closest('[data-product-root]');
    if (!root) return;
    var sel = root.querySelector('[data-option-select][data-position="' + b.getAttribute('data-z-pos') + '"]');
    if (!sel || sel.value === b.getAttribute('data-z-wert')) return;
    sel.value = b.getAttribute('data-z-wert');
    var gruppe = b.parentNode;
    gruppe.querySelectorAll('[data-z-wert]').forEach(function (x) {
      var an = x === b;
      x.classList.toggle('ist-an', an);
      x.setAttribute('aria-checked', an ? 'true' : 'false');
    });
    var feld = gruppe.closest('.z-opt');
    var name = feld && feld.querySelector('.z-opt-gewaehlt b');
    if (name) name.textContent = b.getAttribute('data-z-name');
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  });
  /* Pfeiltasten innerhalb einer Gruppe */
  document.addEventListener('keydown', function (e) {
    var b = e.target.closest && e.target.closest('[data-z-wert]');
    if (!b || ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) return;
    var alle = Array.prototype.slice.call(b.parentNode.querySelectorAll('[data-z-wert]'));
    var i = alle.indexOf(b) + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1);
    var z = alle[(i + alle.length) % alle.length];
    e.preventDefault(); z.focus(); z.click();
  });
})();

/* 4.7 (20.09.2026, Pascal: „Die Details, Versand, Rückgabe … müssen weiter
   runter, darunter erklären wir ja alles“). Nur am Handy und nur auf Seiten
   mit der Landing-Vorlage: Szenen und Häufige Fragen wandern direkt unter
   „So geht's“ – vor die Aufklapper (Reihenfolge per CSS order in
   zinke-premium.css). Am Laptop bleibt alles, wo es ist. */
(function () {
  function hoch() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var landing = document.querySelector('.z-landing');
    var layout = document.querySelector('[data-product-root] .product-layout');
    if (!landing || !layout || landing.classList.contains('z-landing-oben')) return;
    landing.classList.add('z-landing-oben');
    layout.appendChild(landing);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hoch); else hoch();
})();
